import React from "react";

function NFTLoanHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-8 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  NFT Development & Launching Services
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Join the revolution & partner with us to launch your own
                    NFTs in the market! We design, develop & mint NFTs on
                    different blockchain ecosystems!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NFTLoanHero;
